<div class="recipient-select">

    <div class="selected-recipients">
        <pui-badge-group [counterVariant]="'info'">
            @for (recipient of selectedRecipients(); track displayName(recipient)) {
            <pui-badge [variant]="isGroup(recipient) ? 'info' : 'accent'">
                @if (isGroup(recipient)) {
                <span>
                    {{ recipient.name }}
                    ({{recipient.webRqaUsers.length}} użytkowników)
                </span>
                } @else {
                <span>
                    {{ recipient.firstName }}
                    {{ recipient.lastName }}
                    ({{ recipient.email }})
                </span>
                }
                <pui-icon right icon="x-close" [width]="12" [height]="12" class="cursor-pointer"
                    (click)="removeRecipient(recipient)"></pui-icon>
            </pui-badge>
            }
        </pui-badge-group>

    </div>

    <div cdkOverlayOrigin #origin="cdkOverlayOrigin">

        <input #input type="text" [formControl]="searchControl" placeholder="Szukaj odbiorcy lub grupy" />

    </div>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="isOverlayOpen()"
        [cdkConnectedOverlayHasBackdrop]="false"
        [cdkConnectedOverlayWidth]="origin.elementRef.nativeElement.offsetWidth">

        <div class="dropdown">

            @if (recipientService.recipientsResource.isLoading()) {
            <div class="state">
                Szukanie...
            </div>
            }

            @else if (recipientService.recipientsResource.error()) {
            <div class="state error">
                Nie udało się pobrać danych.
            </div>
            }

            @else {

            <table class="results-table">

                @if ((suggestions()?.users?.length ?? 0) > 0) {

                <tr class="section-row">
                    <td colspan="4">
                        Użytkownicy
                    </td>
                </tr>

                @for (user of suggestions()?.users ?? []; track user.username) {
                <tr class="clickable-row" (mousedown)="selectRecipient(user)">

                    <td>
                        <div class="user-name">
                            {{ user.firstName }} {{ user.lastName }}
                        </div>
                        <div class="user-email">{{ user.email }}</div>
                    </td>
                    <td><pui-badge [variant]="user.group | groupColor">{{user.group}}</pui-badge></td>

                    <td>
                        {{ user.organization }}
                    </td>

                    <td>
                        {{ user.responsibleUnit }}
                    </td>


                </tr>
                }

                }

                @if ((suggestions()?.groups?.length ?? 0) > 0) {

                <tr class="section-row">
                    <td colspan="4">
                        Grupy
                    </td>
                </tr>

                @for (group of suggestions()?.groups ?? []; track group.id) {
                <tr class="clickable-row" (mousedown)="selectRecipient(group)">

                    <td>
                        {{ group.name }}
                    </td>

                    <td>
                        {{ group.webRqaUsers.length }} użytkowników
                    </td>

                    <td></td>

                    <td></td>

                </tr>
                }

                }

            </table>

            @if (
            !recipientService.recipientsResource.isLoading()
            && (suggestions()?.users?.length ?? 0) === 0
            && (suggestions()?.groups?.length ?? 0) === 0
            ) {
            <div class="state">
                Brak wyników
            </div>
            }

            }

        </div>

    </ng-template>

</div>